import { UserOrganizationRole } from 'types'

const ASSIGNABLE_REGION_ROLES = [UserOrganizationRole.COMMERCIAL, UserOrganizationRole.SALES_REP]

export const USER = { ASSIGNABLE_REGION_ROLES }
